import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import {ComposedChart, Scatter, Line, CartesianGrid,  XAxis, YAxis, Tooltip, Area } from 'recharts';
//recharts http://recharts.org/en-US/guide/getting-started chartjs?

class Formi extends React.Component {

  constructor(props) {
    let numOfFields = 39; //kysymysten lukumäärä ( 1 kysymys = Kysymys + perustelukysymys )
    let pKysymykset = [3,4,5,6,7,8,15,18,20,21,22,23,24]; //kysymykset joiden kohdalla on 2 kenttää, kysymys ja perustelu
    let osaAlue = [//kysymyksen / kysymysparin osa-alue
      {
        name:"KonMT",
        value: [5, 6, 7, 8, 9, 10, 15, 18, 19, 20, 30, 31, 32, 33, 34, 37, 38, 39]},
      {
        name:"KonEiMT",
        value: [1, 2, 3, 4, 11, 25, 26, 27, 28, 29]},
      {
        name:"Tunne",
        value: [21, 22, 23, 24, 35]},
      {
        name:"RelevKäyt",
        value: [13, 14, 17, 36]},
      {
        name:"VäärUsk",
        value: [12, 16]},
     ];

    //Persentiilitaulukko
    let persentiiliSarake = [4,5,6,7,8]; //ikä
    let csvPersentiili = `
    1;3;3;3;3;3
    2;3;3;3;3;3
    3;3;3;3;3;3
    4;4;3;3;3;3
    5;7;3;3;3;3
    6;11;3;3;3;3
    7;16;3;3;3;3
    8;18;3;3;3;3
    9;25;3;3;3;3
    10;33;3;3;3;3
    11;37;3;3;3;3
    12;44;4;3;3;3
    13;52;14;4;3;3
    14;57;16;5;3;3
    15;64;22;5;3;3
    16;69;24;6;3;3
    17;76;28;8;3;3
    18;80;36;10;3;3
    19;83;44;11;3;3
    20;87;48;12;3;3
    21;90;50;13;3;3
    22;90;55;14;3;3
    23;90;57;16;3;3
    24;90;59;22;5;3
    25;96;69;24;5;3
    26;96;76;29;6;3
    27;97;77;36;9;3
    28;97;81;37;17;5
    29;97;86;41;19;7
    30;97;87;47;28;8
    31;97;95;64;33;9
    32;97;97;72;52;10
    33;97;97;83;63;17
    34;97;97;87;71;30
    35;97;97;89;76;39
    36;97;97;97;82;62
    37;97;97;97;87;78
    38;97;97;97;87;91
    39;97;97;97;87;91
    40;97;97;97;87;91`;
    //CSV taulukko js-taulukoksi:
    let row = {};
    let persentiili = {};
    csvPersentiili = csvPersentiili.trim().replace(/ /g, "");//remove spaces
    csvPersentiili = csvPersentiili.split(/\r?\n/);//split newlines
    csvPersentiili = csvPersentiili.map(i => i.trim().split(";"))//split ";"
    csvPersentiili.forEach( item => {
      row = {};
      for(let i=0; i<persentiiliSarake.length; i++){
        row[persentiiliSarake[i]] = item[i+1].trim();
      }
      persentiili[item[0]] = row; 
    });

    numOfFields += pKysymykset.length; //total number of fields 
    let fields = Array(numOfFields).fill(""); //field values
    let fieldSubmittable = Array(numOfFields).fill(false);
    //Testausarvoja:
    //fields = [1,0,1,1,1,0,1,1,1,1,1,1,1,1,0,1,1,0,1,1,1,1,0,0,1,1,1,1,0,1,1,1,1,1,0,1,1,0,0,1,1,1,1,1,1,1,1,1,1,0,1,1];
    //fieldSubmittable = Array(numOfFields).fill(true);

    //valmistellaan info taulukko jonka pohjalta luodaan kentät, ja translation taulukko
    let key = 0
    let pKys = false;
    let pKysb = 0; //kysymyksen tyyppi 0=kysymys ilman perustelukysymystä, 1, 2 = perustelukysymys
    let type;
    let translation = [];
    let fieldsInfo = [];
    for(let i=0; i<numOfFields; i++){
      if(pKysymykset.includes(key) && !pKys) {
        pKys = true;
        type = "Perustelukysymys";
        pKysb = 2;
      }
      else {
        if(pKysymykset.includes(key+1)) {
          pKysb = 1;
        }
        else {
          pKysb = 0;
        }
        pKys = false;
        key++; //samalla key:llä voi olla monta kysymystä, varsinainen ja perusteluk.
      }
      if(pKysymykset.includes(key) && !pKys) {
      }
      fieldsInfo[i] = {key: key, pkys: pKysb, type: type, val: fields[i]}
      //luodaan translation taulukko
      if(!pKys){ translation[key] = i; }
    }

    let name;
    let translated;
    //päivitetään osaAlueet absoluuttisilla kentän numeroilla
    for(let i=0; i<osaAlue.length; i++){
      name = osaAlue[i].name;
      for(let ii=0; ii<osaAlue[i].value.length; ii++){
        translated = translation[ osaAlue[i].value[ii] ];
        osaAlue[i].value[ii] = translated
        fieldsInfo[translated].type = name;
      }
    }

    //päivitetään pKysymykset absoluuttisilla kentän numeroilla   
    pKysymykset = pKysymykset.map(i => translation[i])

    super(props);
    this.state = {
      isInputView: true,
      submitDisabled: true,
      numOfFields: numOfFields,
      fieldsInfo: fieldsInfo,
      automDisabledFields: [],
      sums: [],
      ageField: "", 
      ageFieldPromptText: "",
      persentiili: persentiili,
      fieldSubmittable: fieldSubmittable,
      fieldDisabled: Array(numOfFields).fill(false),
      results: "",
    };


    this.handleTransition = this.handleTransition.bind(this);
    //this.handleSubmit = this.handleSubmit.bind(this);
    this.handleNumberinput = this.handleNumberinput.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }
 
  handleTransition(){ //toggle
    this.setState({isInputView: !this.state.isInputView},() => {
      window.scrollTo(0, 0)
    });
  }

  handleReset(){
    const fieldsInfo = this.state.fieldsInfo.slice(); //reset fieldsInfo values
    for(let i=0; i<fieldsInfo.length; i++){ fieldsInfo[i].val=""; }
    this.setState({fieldsInfo: fieldsInfo});
    
    this.setState({fieldSubmittable: this.state.fieldSubmittable.slice().fill(false)});
    this.setState({fieldDisabled: this.state.fieldDisabled.slice().fill(false)});

    this.setState({submitDisabled: true, ageField: "", ageFieldPromptText: ""});
  }

  handleChange(evt){ //agefield
    let newValue = evt.target.value.replace(/[^x45678]/g, '').slice(-1); //keep x, numbers 4-8
    this.setState({[evt.target.name]: newValue},() => this.checkAllFields());

    if(newValue!=="") { this.setState({ageFieldPromptText: ""}); }
  }

  moveToNextField(currentField){
    let numFields = this.state.fieldsInfo.length-1; //number of fields = 52
    let id = parseInt(currentField);
    while (id < numFields) {//find next allowed id
      id++;
      if(this.state.fieldDisabled[id]===false) { break; } 
    }
    const element = document.getElementById(id);
    if(element !== null) {element.focus();}
    if(parseInt(currentField)===numFields) { document.activeElement.blur(); } //fix to prevent last field selection
  }

  handleFocus(evt){
    //moving selection to allowed field (tabulator)
    if(this.state.fieldDisabled[evt.target.id]===true) { //true = field not allowed for select
      this.moveToNextField(evt.target.id);
    }

    //cursor at the end
    let temp_value = evt.target.value
    evt.target.value = ''
    evt.target.value = temp_value
  }

  handleNumberinput(event){
    let newValue = event.target.value.replace(/[^01xX]/g, '').slice(-1); //keep: 0 1 x X

    const fieldsInfo = this.state.fieldsInfo.slice(); //copy array with slice()
    const fieldSubmittable = this.state.fieldSubmittable.slice();

    ///disabloidaan perustelykysymys kenttiä tarvittaessa
    const fieldDisabled = this.state.fieldDisabled.slice();
    const nextFieldId = parseInt(event.target.id)+1
    if(fieldDisabled.length > nextFieldId) { //skip if last field
      if(this.state.fieldsInfo[parseInt(event.target.id)].pkys===1) { //pkys 1 = kysymys jolla perustelukysymys
        if(newValue==="0" || newValue.toLowerCase()==="x") { //Jos varsinaisessa kysymyskentässä 0 tai X, perustelukysymyskenttään X
          fieldDisabled[nextFieldId] = true; //disable and hide field 
          fieldsInfo[nextFieldId].val = "x"; //set value to x
          fieldSubmittable[nextFieldId] = true;
        }
        else {
          fieldDisabled[nextFieldId] = false;
          if(newValue==="") {//Tyhjä kenttä tyhjentää myös perustelukysymyskentän 
            fieldsInfo[nextFieldId].val = ""; 
            fieldSubmittable[nextFieldId] = false;
          }
        }
      }
    }

    let currentId = event.target.id;

    this.setState({fieldDisabled: fieldDisabled},() => {
      if(newValue!=="") { this.moveToNextField(currentId); } //callback, move selection to next field
    });


    //Update changed field value
    fieldsInfo[event.target.id].val = newValue;

    //lasketaan peräkkäisten virheiden määrä ei perustelukysymyksissä välillä 0-20 (kysymys 20 = kenttä 29)
    let virheet = 0;
    let i = 0;
    for (i = 0; i < 29; i++) { 
      if(fieldsInfo[i].type !== "Perustelukysymys") {
        if(fieldsInfo[i].val === "0") {
          virheet++;
        }
        else {
          virheet=0;
        }
        if(virheet === 6) { break; }
      }
    }

    if(virheet === 6) { //jos löytyi 6 tai enemmän peräkkäisiä virheitä
      
      if(this.state.automDisabledFields.length === 0){
        let automDisabledFields = [];
        for (i = 0; i < 29; i++) {
          if(fieldsInfo[i].val === "") {
            fieldDisabled[i] = true;
            automDisabledFields.push(i);
            fieldsInfo[i].val = "x";
            fieldSubmittable[i] = true;
          }
        }
        for (i = 47; i < 52; i++) {
          if(fieldsInfo[i].val === "") {
            fieldDisabled[i] = true; 
            automDisabledFields.push(i);
            fieldsInfo[i].val = "x";
            fieldSubmittable[i] = true;
          }
        }
        this.setState({automDisabledFields: automDisabledFields});
      }
    }
    else {
      if(this.state.automDisabledFields.length > 0) {
        this.state.automDisabledFields.forEach( fieldNum => {
          fieldDisabled[fieldNum] = false; 
          fieldsInfo[fieldNum].val = "";
          fieldSubmittable[fieldNum] = false;
        });
        this.setState({automDisabledFields: []});
      }
    }

    this.setState({fieldsInfo: fieldsInfo});

    function checkField(value) {
      return ((value!=="" && !isNaN(value)) || value.toLowerCase()==="x")
    }
     //Update fieldSubmittable true/false
    fieldSubmittable[event.target.id] = checkField(newValue);
    this.setState({fieldSubmittable: fieldSubmittable},() => this.checkAllFields()); //update states  
  }

  checkAllFields(){
        //Checking full FieldSubmittable array
        let allFieldsTrue = true
        for (let i of this.state.fieldSubmittable) {
          if(i===false) { allFieldsTrue = false }
        }
        //Check Age
        if(this.state.ageField==="") {
          allFieldsTrue = false
          this.setState({ageFieldPromptText: "Pakollinen kenttä. Ilmoita ikä välillä 4-8"});
        }
    
        //Enable/disable submit
        this.setState({submitDisabled: !allFieldsTrue}); 
  }

  dateNow() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(0, '0');
    let mm = String(today.getMonth() + 1).padStart(0, '0'); //January is 0!
    let yyyy = today.getFullYear();
    today = dd + '.' + mm + '.' + yyyy;
    return today
  }
  
  sumPoints(array, type= "type"){
    let sums = []
    let number;
    array.forEach( item => {
      if(typeof(sums[item[type]]) === 'undefined') {
        sums[item[type]] = 0;
      }
      number = parseFloat(item.val);
      if(!isNaN(number)) { sums[item[type]] += number; }
      }
    );
    return sums;
  }

  tuenTarve(persentiili){
    if(isNaN(parseFloat(persentiili))) {return "-";}
    if(persentiili<=6) {return "Selvästi tuen tarpeessa";}
    if (persentiili<=15) {return "Tuen tarpeessa";}
    if (persentiili<=25) {return "Seurattava";}
    else {return "Ei tuen tarpeessa";}
  }

  persentiiliarvo(sisaltopisteet,age){
    if(typeof(this.state.persentiili[sisaltopisteet]) === 'undefined') { return ""; }
    if(typeof(this.state.persentiili[sisaltopisteet][age]) === 'undefined') { return "Persentiiliarvo on saatavilla vain 4-8 vuotiaille."; }
    return this.state.persentiili[sisaltopisteet][age];
  }
  
  render() {
    let resultsView;
    let inputView;
    let numberInputs = [];

    //luodaan kysymys kenttiä
    for(let i=0; i<this.state.fieldsInfo.length; i++){
      let submittable = this.state.fieldSubmittable[i] ? 'submittable' : 'notsubmittable' ; 
      if(this.state.fieldDisabled[i]){submittable='disabled'};
      let text = this.state.fieldsInfo[i].type==="Perustelukysymys" ? this.state.fieldsInfo[i].key+'b:' : this.state.fieldsInfo[i].key+':'; 
      numberInputs.push(
      <div key={i}>
        <span className="label">{text}</span>
        <input id={i} type="text" className={submittable} onFocus={this.handleFocus} onChange={this.handleNumberinput} value={this.state.fieldsInfo[i].val} autoComplete="off"/>
      </div>
      )
    }

    let results = [];

    //laske taulukkoon yhteispisteet kaikille osa-alueille
    let type = this.sumPoints(this.state.fieldsInfo,"type");
    let pkys = this.sumPoints(this.state.fieldsInfo,"pkys");
   
    let sisaltopisteet = type["KonEiMT"]+type["KonMT"]+type["VäärUsk"]+type["RelevKäyt"]+type["Tunne"];

    let suhtlPisteet = "Ei laskettavissa";
    if(pkys[1]!==0){
      suhtlPisteet = (pkys[2]/pkys[1]*100).toFixed(1);
    }

    let persentiiliarvo = this.persentiiliarvo(sisaltopisteet,this.state.ageField);
    let tuentarve = this.tuenTarve(persentiiliarvo);
    
    if(!this.state.submitDisabled) {
      results.push(
        <div key="results-field">
          <br />
          KonEiMT: &nbsp; {type["KonEiMT"]} /10<br />
          KonMT: &nbsp; {type["KonMT"]} /18<br />
          VäärUsk: &nbsp; {type["VäärUsk"]} /2<br />
          RelevKäyt: &nbsp; {type["RelevKäyt"]} /4<br />
          Tunne: &nbsp; {type["Tunne"]} /5<br />
          Sisältöpisteet: &nbsp; {sisaltopisteet} /39<br />
          <br />
          Perustelukysymysten pisteet: &nbsp; {pkys[2]} /13 <br />
          Perustelukysymysten suhteelliset pisteet: &nbsp; {suhtlPisteet}<br />
          <br />
          Persentiiliarvo: &nbsp; {persentiiliarvo} <br />
          Tuen tarve: &nbsp; {tuentarve}<br />
          <br />
        </div>
      )
    }

    if(this.state.isInputView){ //Aloitusnäkymä
    inputView = (
      <div>
        <div className="bluebar"></div>
        <div className="inputview">
        <form><h2>Pragma-testi</h2>
        <button className="resetbutton" type='button' onClick={this.handleReset}>Tyhjennä</button>
        <br /><b>Täyttöohje:</b><br />
        Merkitse kysymysten pisteet numeroin ja välistä jätetty kysymys merkillä X.<br /><br /><br />
          <div className="age">
            <b>Lapsen ikä:</b><input type="text" name="ageField" onChange={this.handleChange} value={this.state.ageField} autoComplete="off"/>
            &nbsp; <span className="errorprompt">{this.state.ageFieldPromptText}</span>
          </div>
          <br /><br /><b>Kysymykset:</b>  <br />
          <div className="numberinputs">
            {numberInputs}
          </div>
          <button type='button' onClick={this.handleTransition} disabled={this.state.submitDisabled}>Näytä tulokset</button>
        </form>
        </div>
        {results}
      </div>

    );}

    else { //Tulosnäkymä

      // Kaavion pohja arvot
      let kaavioData = [
        {
          name: '4-vuotiaat', age: '4', uv: 7, pv: 9, median: 12, alue: [7,19]},
        {
          name: '5-vuotiaat', age: '5', uv: 14, pv: 16, median: 22, alue: [14,28]},
        {
          name: '6-vuotiaat', age: '6', uv: 23, pv: 25, median: 31, alue: [23,33],},
        {
          name: '7-vuotiaat', age: '7', uv: 28, pv: 29, median: 32, alue: [28,36],},
        {
          name: '8-vuotiaat', age: '8', uv: 33, pv: 33, median: 36, alue: [33,37],},
      ];

      // Lisätään kaavion piste
      let row = kaavioData.find(element => element.age === this.state.ageField); 
      if(typeof row !== 'undefined') {
        row.score = sisaltopisteet
      }


      let datab = []
      for(let i=0; i<this.state.fieldsInfo.length; i++){
        datab.push({key: i, name: "Arvo "+(i+1), Arvo: this.state.fieldsInfo[i]},)
      }

      //pysty-viivat
      const xAxisTick = ({ x, y, payload }) => {
        const { value } = payload;
        return (
        <svg>
          <text x={x} y={y+9} textAnchor="middle">{value}</text>
          <line x1={x+71} y1={y-9} x2={x+71} y2={y - 369} stroke="LightGray" stroke-width="1" />
        </svg>
        );
      };

      //vaaka-viivat
      const yAxisTick = ({ x, y, payload }) => {
        const { value } = payload;
        const height = 28.5/3;
        const width = 800-62;
        return (
        <svg>
          <text x={x-10} y={y+4} textAnchor="middle">{value}</text>
          <line x1={x+9} y1={y-height} x2={x+width} y2={y-height} stroke="LightGray" stroke-width="1" />
          <line x1={x+9} y1={y-height*2} x2={x+width} y2={y-height*2} stroke="LightGray" stroke-width="1" />
        </svg>
        );
      };

      const renderLineChart = (
        <div className="chart">
        <ComposedChart width={800} height={400} data={kaavioData}>

          <CartesianGrid stroke="LightGray" vertical={false} className='linestyle'/>
          <XAxis dataKey="name" type="category" domain={['dataMin', 'dataMax']} interval={0} tickLine={false} padding={{ left: 72, right: 72 }} unit="" tick={xAxisTick} />
          <YAxis tickCount={14} minTickGap={0} domain={[0, 39]} tick={yAxisTick} label={{ value: 'Kokonaispisteet', angle: -90, offset: 12, position: 'insideLeft', textAnchor: 'middle' }}/>

          <Area dataKey="alue" stroke="#888888" name="Tyypillinen suoritusalue" fill="#999999" strokeWidth={0} isAnimationActive={false}/>
          <Line dataKey="median" stroke="#000000" name="Mediaani" strokeWidth={1} dot={false} isAnimationActive={false} />
          <Line dataKey="pv" stroke="#000000" name="Alaraja 16%" strokeDasharray="2 2" strokeWidth={2} dot={false} isAnimationActive={false}/>
          <Line dataKey="uv" stroke="#000000" name="Alaraja 25%" strokeDasharray="2 2" strokeWidth={2} dot={false} isAnimationActive={false} />
          <Scatter name="Kokonaispisteet" dataKey="score" fill="black" />

          <Tooltip label='-vuotiaat' unit='-vuotiaat'/>
        </ComposedChart>
        </div>
      );
     
      
      resultsView = (
      <div className="resultsview">
        <div className="text">
          <button onClick={this.handleTransition}>Takaisin</button>
          <h2>Pragma-testi</h2><br />

          Testaajan nimi: ________________________________________<br /><br />
          Lapsen nimi: ________________________________________<br /><br />
          Lapsen ikä: &nbsp; {this.state.ageField}<br /><br />
          Testauspäivämäärä: &nbsp; {this.dateNow()}<br />
          {results}
          <br />
        </div>
        {renderLineChart}
        <div className="text">
          <br />
          <img src="selite.png" alt="Selite"/><br /><br />
          (ks. tarkemmin kaavion tulkinnasta testikäsikirjan liite 4)<br />
          <button className="printbutton" type='button' onClick={window.print}>Tulosta</button>
        </div>
      </div>
      );
    }

    return (
      <div>
        {inputView}
        {resultsView}
      </div>
    );
  }
}
// ========================================
ReactDOM.render(<Formi />, document.getElementById("root"));
